import React from 'react'
import contactinfo from'./contentmapcontact'
import FormCntl from '../FormCntrl'
class Contact extends React.Component {

  	render() {
	return(
		 
		   <section id="contact" class="wow fadeInUp">
		  <div class="container">
        <div class="section-header">
          <h2>Contact Us</h2>
          <p>  Contact <b>Nature Hearing Aid Service</b> now and send in this form below to get your questions answered.
</p>
        </div>

        <div class="row contact-info">

 {contactinfo.map((item, index) => (
					
				 <div class="col-md-4">
            <div class="contact-address">
              <i class="ion-ios-location-outline"></i>
              <h3>{item.title}</h3>
              <address>{item.description}</address>
            </div>
          </div>
				))}
        </div>
      </div>
	  
		  <div class="container mb-4">
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15553.820565498592!2d77.5996032!3d12.9427019!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc493a1a934006e5!2sNATURE%20HEARING%20AID%20SERVICE%20AND%20PRODUCTION%20LAB-HEARING%20AID%20REPAIR%20AND%20SERVICES%20IN%20LAKKASANDRA!5e0!3m2!1sen!2sin!4v1584861347054!5m2!1sen!2sin" className="google-map" frameborder="0" allowfullscreen></iframe>
         
        
      </div>
      <div class="form">
        <FormCntl/>
      </div>
        

      
		 </section>
 )}
	}
 export default Contact